module.exports = __webpack_public_path__ + "static/img/property_1_gopay.1acc908.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/property_1_gopay.png
// module id = v25a
// module chunks = 1